import axios from "axios";

type IPluginConfig = {
    trackingId: string;
};

const defaultConfig = {
    enabled: true,
};

export default function teacherPlugin(pluginConfig: IPluginConfig) {
    return {
        name: "teacher-plugin",
        config: {
            ...defaultConfig,
            ...pluginConfig,
        },

        initialize: () => {},

        loaded: () => {
            return true;
        },

        identify: () => {},

        track: ({ payload }) => {
            const {
                event,
                properties,
                options: { dumpTeacherEvent },
            } = payload;

            if (dumpTeacherEvent) {
                // console.log(process.env.NEXT_PUBLIC_TEACHER_ANALYTICS_ENDPOINT);
                // console.log("teacher_plugin", event, properties);
                axios
                    .post(
                        process.env.NEXT_PUBLIC_TEACHER_ANALYTICS_ENDPOINT ||
                            "",
                        payload,
                    )
                    .then((res) => console.log(res.status));
            }
        },
    };
}
